import { coco } from '@cotera/api';
import { v4 } from 'uuid';
import { setSignupPendingChatSubmission } from '../v1/chat/models/pending-chat-submission';

/**
 * Captures prompt and promptTitle from URL params and prepares a pending chat
 * submission directly so V1 can route to the generated chat and auto-submit it.
 * The prompt param is expected to be base64-encoded.
 * localStorage is used so it persists across WorkOS auth redirects.
 */
export function captureSignupPromptFromUrl(): void {
  if (typeof window === 'undefined') {
    return;
  }

  const urlParams = new URLSearchParams(window.location.search);
  const encodedPrompt = urlParams.get('prompt');
  const promptTitle = urlParams.get('promptTitle');

  if (encodedPrompt === null || encodedPrompt === '') {
    return;
  }

  try {
    // Base64 decode with UTF-8 safety
    const prompt = decodeURIComponent(escape(atob(encodedPrompt)));
    const resolvedPromptTitle = promptTitle ?? '';
    const text =
      resolvedPromptTitle !== ''
        ? `# ${resolvedPromptTitle}\n\n${prompt}`
        : prompt;
    const conversationId = v4();

    setSignupPendingChatSubmission({
      conversationId,
      text,
      systemSuffix: coco.onboardingSystemSuffix({
        prompt,
        promptTitle: resolvedPromptTitle,
      }),
      messageType: 'hidden',
    });
  } catch {
    // Invalid base64 or encoding — silently ignore
  }
}
